import React from 'react';
import Spinner from './Spinner';
import { useLoading } from '../../contexts/LoadingContext';

const LoadingButton = ({
    loadingKey,
    children,
    className = "",
    ...props
}) => {
    const { isLoading } = useLoading();
    const loading = isLoading(loadingKey);

    return (
        <button
            disabled={loading}
            className={`${className} ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
            {...props}
        >
            <div className="flex items-center justify-center gap-2 h-full">
                {loading && (
                    <div className="flex-none w-6 h-6">
                        <Spinner variant="light" size="h-6 w-6" />
                    </div>
                )}
                <span className="inline-block -translate-y-[1px]">
                    {children}
                </span>
            </div>
        </button>
    );
};

export default LoadingButton;
